var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkbox-toggle d-inline mt-1" }, [
    _c("input", {
      attrs: {
        type: "checkbox",
        id: _vm.getInputKey(),
        disabled: _vm.disabled
      },
      domProps: { checked: _vm.value },
      on: { input: _vm.onInput }
    }),
    _vm._v(" "),
    _c("label", { attrs: { for: _vm.getInputKey() } })
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23b9d310", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b9d310","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/CustomSwitchComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-23b9d310","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/CustomSwitchComponent.vue
// module chunks = 0